const passwordData = [
    0,
    "liberty",
    "indigo",
    "anvil",
    "rogue",
    "justice"
]

export default passwordData